import CollectionGrid from "@components/CollectionGrid"
import CenteredTextBlock from "@components/ContentPage/CenteredTextBlock"
import Footer from "@components/Footer"
import { Container } from "@components/Layout"
import SEO from "@components/SEO"
import { Paragraph } from "@components/Typography"
import { CbSingleCollectionCollections } from "@lib/kontent/models/CbSingleCollectionCollections"
import { CollectionPage } from "@lib/kontent/models/CollectionPage"
import React from "react"

interface Props {
  collection: CollectionPage
}

const Collection: React.FC<Props> = ({ collection }) => {
  const collectionBlocks = collection.collections_grid_items
    .value as any as CbSingleCollectionCollections[]
  return (
    <>
      <SEO
        title={collection.seo__meta_title.value}
        description={collection.seo__meta_description.value}
        imageUrl={collection.seo__meta_image.value[0]?.url}
        urlKey="collection"
      />
      <Container pt={4} pb={5}>
        <CenteredTextBlock titleAs={"h1"} title={collection.page_title.value}>
          <Paragraph>{collection.intro_text.value}</Paragraph>
        </CenteredTextBlock>

        <CollectionGrid items={collectionBlocks} />
      </Container>
      <Footer />
    </>
  )
}

export default Collection
